/**
 * Constants for the rare use cases where we are not dynamic, and must know something about
 * the data model before we execute any code.
 *
 * Use cases are typically features that are default and not customizable, such as aggregated counts
 */

export const tableName = {
  trans: 'tblTrans',
  action: 'TblAction',
  actionObject: 'TblActionObject',
  object: 'TblTransObject',
  comment: 'TblTransProcComments',
  lossPotentialEvaluation: 'TblLossPotEvaluation',
  lossPotentialResidualEvaluation: 'TblLossPotEvaluationRest',
  lossPotentialEvaluationConsequence: 'TblLossPotEvaluationConseq',
  causes: 'TblSynergiCause',
  consequences: 'TblConsequence',
  connectionTypes: 'TblConnectionTypes',
  connectedCases: 'TblTransConnected',
  involvedPerson: 'TblInvolvedPerson',
  green: 'TblGreen',
  checkListInteraction: 'TblInteraction',
  link: 'TblTransLink',
  attachmentType: 'TblAttachmentType',
  involvedDrug: 'TblDrugInvolved',
  drugReactionInteraction: 'TblSuspDrugInteraction',
  signature: 'TblTransSignature',
  economy: 'TblSynergiInsEco',
  checklistCategory: 'TblCheckListCategory',
  checklist: 'TblCheckList' ,
  assessment: 'TblAssessment',
  transLog: 'TblTransLog',
  connectedActionView: 'TblTransConnectedActionView',
  prevGreen: 'TblTransPrevGreen'
};

export const columnName: any = {

  [tableName.action]: {
     numberOfClosedActions: 'numberOfClosedActions',
     numberOfActions: 'numberOfActions',
     actionCompletedDate: 'ActionCompletedDate',
     actionDueStatus: 'ActionDueStatus'
  },

  [tableName.object]: {
    docName: 'AtchDocDocumentName',
    title: 'AtchDocTitle',
    blob: 'AtchDocObjectBlob',
    contentType: 'AtchDocContentType',
    size: 'AtchDocSize',
    thumbnailSize: 'AtchDocThbSize',
    attachedBy: 'AtchDocAttachedBy',
    attachedAt: 'AtchDocAttachedDate',
    mainImage: 'AtchDocFlgMain',
    numberOfFiles: 'numberOfFiles'
  },

  [tableName.actionObject]: {
    docName: 'ActAtchDocumentName',
    title: 'ActAtchTitle',
    blob: 'ActAtchObjectBlob',
    contentType: 'ActAtchContentType',
    size: 'ActAtchSize',
    thumbnailSize: 'ActAtchThbSize',
    attachedBy: 'ActAtchAttachedBy',
    attachedAt: 'ActAtchAttachedDate',
    mainImage : 'ActAtchFlgMain'
  },

  [tableName.comment]: {
    numberOfComments: 'numberOfComments',
    submittedBy: 'CmtBlogSubmittedPerson',
    submittedDate: 'CmtBlogSubmittedDate',
    submittedComment: 'CmtBlogComments'
  },

  [tableName.lossPotentialEvaluation]: {
    validFrom: 'PotRiskEvValidFrom'
  },

  [tableName.lossPotentialResidualEvaluation]: {
    validFrom: 'ResPotRiskEvValidFrom'
  },

  [tableName.causes]: {
    numberOfCauses: 'numberOfCauses'
  },

  [tableName.involvedPerson]: {
    numberOfInvolvedPersons: 'numberOfInvolvedPersons'
  },

  [tableName.consequences]: {
    actConsConsequenceIcons: 'ActConsConsequenceIcons',
    actConsLoss: 'ActConsLoss',
    actConsGain: 'ActConsGain'
  },

  [tableName.connectedCases]: {
    connectedSequence: 'ConnectedSequence'
  },

  [tableName.link]: {
    title: 'AtchLinkTitle',
    linkUrl: 'AtchLinkUrl',
    anchorIndicator: 'linkUrl',
    numberOfLinks: 'numberOfLinks'
  },

  [tableName.involvedDrug]: {
    numberOfInvolvedDrugs: 'numberOfInvolvedDrugs'
  },

  [tableName.green]: {
    envValSubstance: 'EnvValSubstance',
    envValSubstanceCategory: 'EnvValSubstanceCategory'
  },

  [tableName.signature]: {
    signaturePerson: 'SignaturePerson',
    signatureType: 'SignatureType',
    signatureDate: 'SignatureDate'
  },

  [tableName.economy]: {
    costEstimate: 'InsurCostEstimate'
  },

  [tableName.checklist]: {
    checkListEvaluation: 'CheckListEvaluation'
  },

  [tableName.assessment]: {
    numberOfAssessments: 'numberOfAssessments'
  },

  [tableName.transLog]: {
    caseLogs: 'processingLogs',
    caseLogNo: 'CaseLogNo',
    caseLogXml: 'CaseLogXmlObjectBlob'
  },

  [tableName.trans]: {
    confidential: 'Confidential',
    confidentialIndicator: 'confidential'
  },

  [tableName.connectedActionView]: {
    numberOfConnectedClosedActions: 'ConnectedCaseActViewActComp'
 },

 [tableName.prevGreen]: {
  amount: 'PrevEnvValAmount',
  unitOfMeasure: 'PrevEnvValUomAmoun',
  caseNo: 'PrevEnvValCaseNo',
  periodStart: 'PrevEnvValPeriodStart',
  periodEnd: 'PrevEnvValPeriodEnd',
  greenNo: 'PrevEnvValGreenNo',
  substanceCategory: 'PrevEnvValSubstanceCategory',
  substance: 'PrevEnvValSubstance'
  }
};

export const statusIndicatorTable: any = {
  [tableName.action]: {
    statusIndicator: 'actionDueStatus'
  }
};

export type CaseConnectionIdentifier = { [name: string] : 1 | 2 };

export const connectionType: CaseConnectionIdentifier = {
  superior: 1,
  subordinate: 2
};

export const propNameConnectionType = {
  [connectionType.superior]: {
    numberOfSuperiorCases: 'numberOfSuperiorCases'
  },
  [connectionType.subordinate]: {
    numberOfSubordinateCases: 'numberOfSubordinateCases'
  }
};
